<template>
  <div class="dashboard-page">
    <div class="dashboard-grid"></div>
    <div class="dashboard-glow glow-1"></div>
    <div class="dashboard-glow glow-2"></div>

    <main class="main-content">
      <header class="topbar">
        <div>
          <p class="eyebrow">Área autenticada</p>

          <h1>Bem-vindo à plataforma interna</h1>

          <p class="topbar-text">
            Acesso centralizado às aplicações autorizadas para o teu perfil.
          </p>
        </div>

        <div class="topbar-actions">
          <button
            v-if="isAdmin"
            type="button"
            class="nav-pill-btn"
            @click="goToAdminPanel"
          >
            {{ isAdminPage ? 'Dashboard' : 'Entrar no Painel Administrativo' }}
          </button>

          <div class="status-card">
            <span class="status-dot"></span>
            <span>Sessão autenticada</span>
          </div>

          <button
            type="button"
            class="logout-btn"
            @click="logout"
          >
            Logout
          </button>
        </div>
      </header>

      <router-view />
    </main>
  </div>
</template>

<script>
import keycloak from '../keycloak'

export default {
  name: 'Layout',

  computed: {
    isAdmin() {
      const roles =
        keycloak.tokenParsed?.realm_access?.roles || []

      return roles.includes('admin')
    },

    isAdminPage() {
      return this.$route.path === '/admin-panel'
    }
  },

  methods: {
    goToAdminPanel() {
      if (this.isAdminPage) {
        this.$router.push('/dashboard')
        return
      }

      this.$router.push('/admin-panel')
    },

    async logout() {
      /*
       * Informa o LoginView de que o utilizador fez logout
       * explicitamente da aplicação.
       *
       * A conta Microsoft pode continuar guardada no MSAL,
       * mas o login automático deve ficar bloqueado quando
       * o utilizador chega ao login após carregar em Logout.
       */
      sessionStorage.setItem('app_logout_done', '1')

      /*
       * Limpa dados temporários que poderiam provocar uma
       * nova autenticação Microsoft automática.
       */
      sessionStorage.removeItem('msal_response')
      sessionStorage.removeItem('microsoft_link_done')

      try {
        await keycloak.logout({
          redirectUri: process.env.VUE_APP_URL
        })
      } catch (error) {
        console.error('Erro ao terminar sessão Keycloak:', error)

        /*
         * Mantemos a flag app_logout_done para que, mesmo em caso
         * de erro no logout, o LoginView não volte a autenticar
         * automaticamente com a conta Microsoft.
         */
        window.location.href = process.env.VUE_APP_URL
      }
    }
  }
}
</script>